import type { ApiErrorBody, Play, PlaySummary, Role, Session } from "../types";

export class ApiError extends Error {
  status: number;
  body: ApiErrorBody;

  constructor(status: number, body: ApiErrorBody) {
    super(body.error || "请求失败");
    this.status = status;
    this.body = body;
  }
}

async function request<T>(path: string, init?: RequestInit): Promise<T> {
  const response = await fetch(`/api${path}`, {
    ...init,
    headers: { "Content-Type": "application/json", ...init?.headers },
    credentials: "same-origin",
  });
  if (!response.ok) {
    let body: ApiErrorBody = { error: `请求失败（${response.status}）` };
    try {
      body = (await response.json()) as ApiErrorBody;
    } catch {
      // 使用默认错误信息。
    }
    throw new ApiError(response.status, body);
  }
  if (response.status === 204) return undefined as T;
  return response.json() as Promise<T>;
}

export const api = {
  session: () => request<Session>("/session"),
  login: (role: Role, password: string) =>
    request<Session>("/login", { method: "POST", body: JSON.stringify({ role, password }) }),
  logout: () => request<void>("/logout", { method: "POST" }),
  listPlays: () => request<{ plays: PlaySummary[] }>("/plays"),
  getPlay: (id: string) => request<{ play: Play }>(`/plays/${encodeURIComponent(id)}`),
  createPlay: (play: Play) =>
    request<{ play: Play }>("/plays", { method: "POST", body: JSON.stringify(play) }),
  updatePlay: (play: Play) =>
    request<{ play: Play }>(`/plays/${encodeURIComponent(play.id)}`, {
      method: "PUT",
      body: JSON.stringify(play),
    }),
  deletePlay: (id: string) => request<void>(`/plays/${encodeURIComponent(id)}`, { method: "DELETE" }),
  exportBackup: () => request<{ exportedAt: string; plays: Play[] }>("/backup"),
  importBackup: (plays: Play[]) =>
    request<{ imported: number }>("/import", { method: "POST", body: JSON.stringify({ plays }) }),
};
